import { Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import Layout from './Layout';

const NotFoundPage = () => {
  return (
    <Layout>
      <div className="min-h-[60vh] flex flex-col items-center justify-center py-20 text-center px-4">
        <div className="text-8xl font-bold text-gray-200 mb-4">404</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Page not found</h1>
        <p className="text-lg text-gray-600 mb-8 max-w-md">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700"
        >
          <Home className="mr-2 h-5 w-5" />
          Back to Home
        </Link>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
